const isProduction = process.env.NODE_ENV === 'production';

// Main Backend (MB) - All requests go through MB, which proxies to downstream services
// Priority: 1) REACT_APP_MAIN_BACKEND_URL env var, 2) Hardcoded fallback
// For production deployments, prefer setting REACT_APP_MAIN_BACKEND_URL in .env
const PROD_MAIN_BACKEND_URL = 'https://werkbudy-mb-backend-346636525778.europe-west1.run.app';
const DEV_MAIN_BACKEND_URL = 'http://localhost:8080';

export const MAIN_BACKEND_URL =
  process.env.REACT_APP_MAIN_BACKEND_URL ||
  (isProduction ? PROD_MAIN_BACKEND_URL : DEV_MAIN_BACKEND_URL);

// MB Proxy Routes (all requests go through MB)
export const API_BASE_URL = `${MAIN_BACKEND_URL}/api/fastapi`; // FastAPI backend via MB
export const LLM_BACKEND_URL = `${MAIN_BACKEND_URL}/api/llm`; // LLM backend via MB
export const AUTH_API_BASE_URL = `${MAIN_BACKEND_URL}/auth`; // Authentication via MB

// Toggle to use mock API responses
export const USE_MOCK_API = false; // Set to false to use real backend

// OpenAI direct access (used in some fallbacks)
export const OPENAI_API_URL = 'https://api.openai.com/v1/chat/completions';
export const OPENAI_API_KEY = process.env.REACT_APP_OPENAI_API_KEY || '';
export const OPENAI_MODEL = 'gpt-4o-mini';

// LLM Backend Auth Secret (still needed for LLM backend's own auth, passed through MB)
export const LLM_BACKEND_AUTH_SECRET =
  process.env.REACT_APP_LLM_BACKEND_AUTH_SECRET || 'my-secret-auth-key-123';